import React, { useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from "../../contexts/user.context";
import Navbar from '../navbar/navbar.comp';
import TimelineCard from '../timelineCard/timelineCard.comp';
import {
    getAcceptedChallengesForUser,
    deleteAcceptedChallenge,
    getDoneAcceptedChallengesForUser
} from "../../utils/firebase/firebase.utils";
import './doneChallenges.style.scss';
import AcceptedChallengeEvent from '../acceptedChallengeEvent/acceptedChallengeEvent.comp';
import Button from '../button/button.comp';
import { initialAcceptedChallenges } from '../../utils/initialObjects.comp'
import { formatDateShort, getDayOfWeek, days } from '../../utils/dating.utils';

const DoneChallenges = () => {

    // Nav & Contexts
    const navigate = useNavigate();
    const { userID } = useContext(UserContext);


    //Loading Challenge
    const [challenges, setChallenges] = useState(initialAcceptedChallenges);
    const [doneChallenges, setDoneChallenges] = useState(initialAcceptedChallenges);
    const [loadedBoolean, setLoadedBoolean] = useState(false)
    useEffect(() => {
        const timer = setTimeout(async () => {
            const loadedChallenges = await getDoneAcceptedChallengesForUser(userID);

            loadedChallenges.sort((a, b) => {
                const dateA = new Date(a.last_day); // Parse the string into a Date object
                const dateB = new Date(b.last_day); // Parse the string into a Date object
                return dateB - dateA; // Sort in descending order (newest first)
            });

            setChallenges(loadedChallenges);

            const doneChallenges = loadedChallenges.filter(challenge => challenge.done_flag === true);
            setDoneChallenges(doneChallenges);

            setLoadedBoolean(true)
        }, 1);

        return () => clearTimeout(timer);
    }, []);


    //Refresh
    const handleRefresh = async () => {
        const loadedChallenges = await getDoneAcceptedChallengesForUser(userID);
        loadedChallenges.sort((a, b) => {
            const dateA = new Date(a.last_day); // Parse the string into a Date object
            const dateB = new Date(b.last_day); // Parse the string into a Date object
            return dateB - dateA; // Sort in descending order (newest first)
        });
        setChallenges(loadedChallenges);
    }


    //Pop Up: Display Challenge Info
    const [displayInfo, setDisplayInfo] = useState(false)
    const [challengeToDisplayId, setChallengeToDisplayId] = useState(false)
    const handleDisplayChallengeInfo = (id) => {
        setChallengeToDisplayId(id)
        setDisplayInfo(true)
    }
    const challengeToDisplay = challenges.find(challenge => challenge.id === challengeToDisplayId);
    const handleClosePopUp = () => {
        setDisplayInfo(false)
        setChallengeToDisplayId(false)
    }

    //Pop Up: Removing Challenge 
    const [removingChallenge, setRemovingChallenge] = useState(false)
    const handleRemoveChallenge = () => {
        setDisplayInfo(false)
        setRemovingChallenge(true)
    }
    const handleCloseRemovingChallengePopUp = () => {
        setRemovingChallenge(false)
        setChallengeToDisplayId(false)
    }
    const [removing, setRemoving] = useState(false)
    const [removed, setRemoved] = useState(false)
    const removeChallengeFromFirebase = () => {
        try {
            setRemoving(true)
            deleteAcceptedChallenge(challengeToDisplayId)

            setRemoving(false)
            setRemoved(true)
        }
        catch (error) {
            console.error('Error deleteing challenge:', error);
        }
    }
    const handleCloseRemoving = () => {
        setRemovingChallenge(false)
        setChallengeToDisplayId(false)
        setRemoved(false)
        handleRefresh()
    }


    return (
        <div>
            <Navbar option={5} />

            {/* Title */}
            <div className='section tight'>
                <h1 style={{ textAlign: 'left', color: 'var(--fontlightblack1)' }}>Done Challenges</h1>
                <p style={{ textAlign: 'left' }}>All your completed challenges ordered by the last day.</p>
            </div>

            {/* Loading Circle */}
            {
                !loadedBoolean ? (
                    <div className="loading-circle"></div>
                ) : null
            }

            {/* <button onClick={() => console.log("C", challenges, "DC", doneChallenges)}>Done</button> */}

            {/* Challenges List */}
            {
                loadedBoolean ? (
                    <div style={{ marginTop: '40px' }} className='section tight'>
                        {
                            challenges.map((challenge) => {
                                return (
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                        <TimelineCard
                                            imageURL={challenge.imageURL}
                                            title={challenge.title}
                                            dateDone={formatDateShort(challenge.lastDay)}
                                            onDisplayChallengeInfo={() => handleDisplayChallengeInfo(challenge.id)}
                                            challengeObject={challenge}
                                        />
                                    </div>
                                );
                            })
                        }
                    </div>
                ) : null
            }

            {/* Pop Up Info */}
            {
                displayInfo && challengeToDisplay ? (
                    <div className="inf-pop-up-container">
                        <div className="inf-pop-up">
                            <div className="inf-pop-up-header">
                                <div className="title">
                                    <div />
                                    <div
                                        className="close pointer"
                                        style={{
                                            backgroundImage: `url(${'https://logowik.com/content/uploads/images/close1437.jpg'})`,
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center',
                                            backgroundRepeat: 'no-repeat'
                                        }}
                                        onClick={handleClosePopUp}
                                    />
                                </div>
                            </div>
                            <div className="inf-pop-up-scroll-view">
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <div
                                        style={{
                                            backgroundImage: `url(${challengeToDisplay.imageURL})`,
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center',
                                            backgroundRepeat: 'no-repeat',
                                            height: '200px',
                                            width: '200px',
                                            borderRadius: '20px'
                                        }}
                                    />
                                </div>
                                <h2>{challengeToDisplay.title}</h2>
                                <p><strong>{challengeToDisplay.info}</strong></p>
                                <p style={{ fontSize: 'small' }}>Your progress for this challenge</p>

                                {
                                    [1, 2, 3].map((week) => {

                                        return (
                                            <div style={{ marginTop: '40px' }}>
                                                <p style={{ marginBottom: 0 }}>Week {week}</p>
                                                <div style={{ marginBottom: '20px', padding: '4px' }}>
                                                    {
                                                        challengeToDisplay.events.map((row, index) => {

                                                            if (index % 5 === 1 && row === week) {

                                                                const eventsArray = challengeToDisplay.events;

                                                                const dateIndex = index + 2;
                                                                const booleanIndex = index + 3;

                                                                const eventNumber = eventsArray[index - 1];
                                                                const date = formatDateShort(eventsArray[index + 2])
                                                                const boolean = eventsArray[index + 3];

                                                                const dayOfWeek = getDayOfWeek(date);
                                                                const IndexOfDay = days.indexOf(dayOfWeek);

                                                                const dayString = getDayOfWeek(date)
                                                                const dateString = formatDateShort(date);

                                                                return (
                                                                    <AcceptedChallengeEvent
                                                                        eventTitle={challengeToDisplay.title}
                                                                        eventNumber={eventNumber}
                                                                        eventsTotal={challengeToDisplay.eventsTotal}
                                                                        eventTime={challengeToDisplay.eventTime}
                                                                        boolean={boolean}
                                                                        booleanIndex={booleanIndex}
                                                                        indexOfDay={IndexOfDay}
                                                                        dateIndex={dateIndex}
                                                                        dayString={dayString}
                                                                        dateString={dateString}
                                                                        date={date}
                                                                    />
                                                                )
                                                            }
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                                <div className="footer-margin"></div>
                            </div>
                        </div>
                    </div>
                ) : null
            }

            {/* Removing Challenge Pop Up */}
            {
                removingChallenge ? (
                    <div className="inf-pop-up-container">
                        <div className="inf-pop-up">
                            <div className="inf-pop-up-header">
                                <div className="title">
                                    <div />
                                    <div
                                        className="close pointer"
                                        style={{
                                            backgroundImage: `url(${'https://logowik.com/content/uploads/images/close1437.jpg'})`,
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center',
                                            backgroundRepeat: 'no-repeat'
                                        }}
                                        onClick={handleCloseRemovingChallengePopUp}
                                    />
                                </div>
                            </div>
                            {
                                removing ? (
                                    <div className="my-challenge-details-delete-pop-up-scroll-view ">
                                        <p>Deleting challenge...</p>
                                        <div className="my-challenge-details-delete-loading-circle"></div>
                                    </div>
                                ) : (
                                    removed ? (
                                        <div className="my-challenge-details-delete-pop-up-scroll-view ">
                                            <p style={{ fontSize: 'large' }} >Challenge removed</p>
                                            <Button text={'Close'} option={'yellow'} onClick={handleCloseRemoving} />
                                        </div>
                                    ) : (
                                        <div className="inf-pop-up-scroll-view">
                                            <p>Are you sure you want to remove your challenge progress for <strong>{challengeToDisplay.title}</strong>?</p>
                                            <Button text={'remove'} option={'red'} onClick={removeChallengeFromFirebase} />
                                            <p style={{ fontSize: 'small' }}>This cannot be undone</p>
                                            <div className="footer-margin"></div>
                                        </div>
                                    )
                                )
                            }
                        </div>
                    </div>
                ) : null
            }

        </div>
    );
};

export default DoneChallenges;